
import "react-image-lightbox/style.css";
import ReactDOM from "react-dom";
import React from "react";
import App from './components/App';
import './i18n';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';

ReactDOM.render(<App />, document.getElementById('app'));